var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"color":"white","elevation":"20","loading":_vm.loading}},[_c('v-card-text',[_c('canvas',{attrs:{"id":_vm.id,"width":"768","height":"384"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }